const selectors$2 = {
  relatedSection: '[data-related-section]',
  aos: '[data-aos]',
  tabsLi: '[data-tab]',
  tabLink: '.tab-link',
  tabLinkRecent: '.tab-link__recent',
  tabContent: '.tab-content',
};

const classes$2 = {
  current: 'current',
  hidden: 'hidden',
  aosAnimate: 'aos-animate',
  aosNoTransition: 'aos-no-transition',
  focused: 'is-focused',
};

const attributes$1 = {
  dataTab: 'data-tab',
  dataTabIndex: 'data-tab-index',
};

if (!customElements.get('tabs-component')) {
  customElements.define(
    'tabs-component',
    class GlobalTabs extends HTMLElement {
      constructor() {
        super();

        this.a11y = window.a11y;
      }

      connectedCallback() {
        const tabsNavList = this.querySelectorAll(selectors$2.tabsLi);

        this.addEventListener('theme:tab:check', () => this.checkRecentTab());
        this.addEventListener('theme:tab:hide', () => this.hideRelatedTab());

        tabsNavList?.forEach((element) => {
          const tabId = parseInt(element.getAttribute(attributes$1.dataTab));
          const tab = this.querySelector(`${selectors$2.tabContent}-${tabId}`);

          element.addEventListener('click', () => {
            this.tabChange(element, tab);
          });

          element.addEventListener('keyup', (event) => {
            if ((event.code === 'Space' || event.code === 'Enter') && document.body.classList.contains(classes$2.focused)) {
              this.tabChange(element, tab);
            }
          });
        });
      }

      tabChange(element, tab) {
        if (element.classList.contains(classes$2.current)) {
          return;
        }

        const currentTab = this.querySelector(`${selectors$2.tabsLi}.${classes$2.current}`);
        const currentTabContent = this.querySelector(`${selectors$2.tabContent}.${classes$2.current}`);

        currentTab?.classList.remove(classes$2.current);
        currentTabContent?.classList.remove(classes$2.current);

        element.classList.add(classes$2.current);
        tab.classList.add(classes$2.current);

        if (element.classList.contains(classes$2.hidden)) {
          tab.classList.add(classes$2.hidden);
        }

        this.a11y.a11y.removeTrapFocus();

        this.dispatchEvent(new CustomEvent('theme:tab:change', { bubbles: true }));

        element.dispatchEvent(
          new CustomEvent('theme:form:sticky', {
            bubbles: true,
            detail: {
              element: 'tab',
            },
          })
        );

        this.animateItems(tab);
      }

      animateItems(tab, animated = true) {
        const animatedItems = tab.querySelectorAll(selectors$2.aos);

        if (animatedItems.length) {
          animatedItems.forEach((animatedItem) => {
            animatedItem.classList.remove(classes$2.aosAnimate);

            if (animated) {
              animatedItem.classList.add(classes$2.aosNoTransition);

              requestAnimationFrame(() => {
                animatedItem.classList.remove(classes$2.aosNoTransition);
                animatedItem.classList.add(classes$2.aosAnimate);
              });
            }
          });
        }
      }

      checkRecentTab() {
        const tabLink = this.querySelector(selectors$2.tabLinkRecent);

        if (tabLink) {
          tabLink.classList.remove(classes$2.hidden);
          const tabLinkIdx = parseInt(tabLink.getAttribute(attributes$1.dataTab));
          const tabContent = this.querySelector(`${selectors$2.tabContent}[${attributes$1.dataTabIndex}="${tabLinkIdx}"]`);

          if (tabContent) {
            tabContent.classList.remove(classes$2.hidden);

            this.animateItems(tabContent, false);
          }
        }
      }

      hideRelatedTab() {
        const relatedSection = this.querySelector(selectors$2.relatedSection);
        if (!relatedSection) {
          return;
        }

        const parentTabContent = relatedSection.closest(`${selectors$2.tabContent}.${classes$2.current}`);
        if (!parentTabContent) {
          return;
        }
        const parentTabContentIdx = parseInt(parentTabContent.getAttribute(attributes$1.dataTabIndex));
        const tabsNavList = this.querySelectorAll(selectors$2.tabsLi);

        if (tabsNavList.length > parentTabContentIdx) {
          const nextTabsNavLink = tabsNavList[parentTabContentIdx].nextSibling;

          if (nextTabsNavLink) {
            tabsNavList[parentTabContentIdx].classList.add(classes$2.hidden);
            nextTabsNavLink.dispatchEvent(new Event('click'));
          }
        }
      }
    }
  );
}
